/* ═══════════════════════════════════════════
   YAF THEME v3 — Core JS
═══════════════════════════════════════════ */

/* Scroll reveal */
var observer = new IntersectionObserver(function(entries) {
  entries.forEach(function(entry) {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
      observer.unobserve(entry.target);
    }
  });
}, { threshold: 0.08 });

document.querySelectorAll('.reveal').forEach(function(el) {
  observer.observe(el);
});

/* Re-init on Shopify section load (theme editor) */
document.addEventListener('shopify:section:load', function() {
  document.querySelectorAll('.reveal:not(.visible)').forEach(function(el) {
    observer.observe(el);
  });
});
